import {API_URL, authHeaders, jsonHeaders} from "./index";

function queryString(params) {
    const clean = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== ""));
    const qs = new URLSearchParams(clean).toString();
    return qs ? `?${qs}` : "";
}

export async function apiAdminListIaQuizQuestions(filters) {
    const res = await fetch(`${API_URL}/admin/ia-quiz/questions${queryString(filters)}`, {headers: authHeaders()});
    return res.json();
}

export async function apiAdminCreateIaQuizQuestion(question) {
    const res = await fetch(`${API_URL}/admin/ia-quiz/questions`, {
        method: "POST", headers: jsonHeaders(), body: JSON.stringify(question),
    });
    return res.json();
}

export async function apiAdminUpdateIaQuizQuestion(id, question) {
    const res = await fetch(`${API_URL}/admin/ia-quiz/questions/${id}`, {
        method: "PUT", headers: jsonHeaders(), body: JSON.stringify(question),
    });
    return res.json();
}

function transition(action) {
    return async (id, reason) => {
        const res = await fetch(`${API_URL}/admin/ia-quiz/questions/${id}/${action}`, {
            method: "POST", headers: jsonHeaders(), body: JSON.stringify({reason}),
        });
        return res.json();
    };
}

export const apiAdminActivateIaQuizQuestion = transition("activate");
export const apiAdminSuspendIaQuizQuestion = transition("suspend");
export const apiAdminArchiveIaQuizQuestion = transition("archive");
export const apiAdminFlagReviewIaQuizQuestion = transition("flag-review");

export async function apiAdminListIaQuizQuestionReviews(id) {
    const res = await fetch(`${API_URL}/admin/ia-quiz/questions/${id}/reviews`, {headers: authHeaders()});
    return res.json();
}

export async function apiAdminListIaQuizReports(status) {
    const res = await fetch(`${API_URL}/admin/ia-quiz/reports${queryString({status})}`, {headers: authHeaders()});
    return res.json();
}

export async function apiAdminResolveIaQuizReport(id) {
    const res = await fetch(`${API_URL}/admin/ia-quiz/reports/${id}/resolve`, {
        method: "POST", headers: authHeaders(),
    });
    return res.json();
}

export async function apiAdminGetIaQuizDashboard() {
    const res = await fetch(`${API_URL}/admin/ia-quiz/dashboard`, {headers: authHeaders()});
    return res.json();
}

export async function apiAdminRunIaQuizReviewCycle() {
    const res = await fetch(`${API_URL}/admin/ia-quiz/review-cycle/run`, {
        method: "POST", headers: authHeaders(),
    });
    return res.json();
}

export async function apiAdminEstimateIaQuizAiReview() {
    const res = await fetch(`${API_URL}/admin/ia-quiz/ai-review/estimate`, {headers: authHeaders()});
    return {ok: res.ok, data: await res.json()};
}

export async function apiAdminRunIaQuizAiReview() {
    const res = await fetch(`${API_URL}/admin/ia-quiz/ai-review/run`, {
        method: "POST", headers: authHeaders(),
    });
    return res.json();
}
